// components/modal
// модальное окно на основе стилей zurb foundation

import template from './template.jade'
import style from './style.scss'

var name = 'modal'

export default {

  name: name,
  template: template({style: style}),
  replace: false,
  props: ['name', 'components', 'show', 'title', 'footer'],

  data: () => ({
    name: name,
    show: false,
  }),

  methods: {
    onClick(e) {
      e.preventDefault()
      this.$set('show', false)
    },
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/modal-dialog/index.js
 **/